CF.ready(function() {
  const $myForm = document.querySelector('form[data-cf-form]');

  if($myForm) {
    const emailForm = $myForm.querySelector('[name="email"]');
	
		if(emailForm) {
			var validation = {
				comparator: function isValid(fieldValue) {
					// const domainScript = document.getElementById('arrow-domain-list');
					// let allowedDomains = [];
					
					// if (domainScript) {
					// 	try {
					// 		allowedDomains = JSON.parse(domainScript.textContent);
					// 	} catch (error) {
					// 		console.error("Failed to parse domain list in validation:", error);
					// 		return true;
					// 	}
					// }

					// メールアドレスが空の場合は無効
					if (!fieldValue || !fieldValue.includes('@')) {
						return false;
					}
					
					// // メールアドレスからドメイン部分を取得
					// const emailDomain = fieldValue.split('@')[1];
					
					// // allowedDomainsにドメインが含まれているかチェック
					// if (!allowedDomains.includes(emailDomain)) {
					// 	return false;
					// }
					
					// ドメインが許可リストに含まれている場合は有効
					return true;
				},
		
				// Display this error message if the comparator does not return true
				errorMessage: 'メールアドレスをご確認ください。',
		
				// If your comparator is asynchronous (if it returns a Promise,) set this to true. 
				// Otherwise, you don't need it. More on this below!
				async: false,
			};
			// Add this validation to all fields with a data column key of "email"
			$myForm.cfForm.addValidator(validation, 'email');
		}
  }
});